import { render } from "./Introduce.vue?vue&type=template&id=017a8ed2"
const script = {}
script.render = render

export default script